import React, { PropsWithChildren } from 'react';

const Content: React.FC<PropsWithChildren> = ({ children }) => <div className="interest-content">{children}</div>;

export default Content;
